import { company } from '~/company/Company';
import CategoriesGridOneSBlock from '~/components/CategoryBlocks/CategoriesGridOneSBlock/CategoriesGridOneSBlock';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { CategoriesGrid1S } from '~/components/isolated/CategoryBlocks/CategoriesGrid1S';
import { useGlobal } from '~/hooks/useGlobal';
import { Category } from '~/stores/CategoriesStore';

const CategoriesGridOneSBlockFactory = ({
  category,
  masked,
  externalLink,
}: {
  category: Category;
  masked: boolean;
  externalLink?: string;
}) => {
  const { isMobile } = useGlobal();

  if (company.newDesignSystemEnabled) {
    return <CategoriesGrid1S category={category} />;
  }

  const items = category.subcategory.map(({ name, previewImage, id }) => ({
    title: name,
    img: previewImage,
    id,
  }));

  return (
    <CategoriesGridOneSBlock
      items={items}
      title={category.name}
      description={category.previewText}
      backgroundColor={category.backgroundColor}
      link={externalLink ?? createCategoryUrl({ id: category.id })}
      isMobile={isMobile}
      tileMaskIncluded={masked}
    />
  );
};

export default CategoriesGridOneSBlockFactory;
